import React from 'react';
import PropTypes from 'prop-types';

export function LabelBlock(props) {
  return <div className={props.className}>{props.children}</div>;
}

LabelBlock.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Child components to this component
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

LabelBlock.defaultProps = {
  className: '',
};
